<template>
  <div class="w-full">
    <div class="px-10 pt-6 pb-6">
      <p class="text-zt-xl text-zt-dark-500">
        {{ $t('message.DownloadAllDocuments.downloadInProgress') }}
      </p>
      <p class="text-zt-xl text-zt-dark-500">
        {{ $t('message.DownloadAllDocuments.pleaseTryAgain') }}
      </p>
    </div>
    <div class="w-full bg-zt-dark-200 py-2 flex pr-6 rounded-b">
      <div class="ml-auto">
        <button
          data-vs-button="close-modal"
          @click="closeModal"
          class="focus:outline-none bg-zt-primary-200 text-white font-medium download--success px-2"
        >
          {{ $t('message.DownloadAllDocuments.understood') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadInitialized',
  inject: ['closeModal'],
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.download--success {
  height: 34px;
  border-radius: 4px;
  background-color: var(--branding-primary, --v-primary-base);
  border: 1px solid var(--branding-primary, --v-primary-base);
}
</style>
